import { ReactSVG } from "react-svg"
import { Header } from "../../components/Header"
import { PaginaStyle } from "./style"
import Zapzap from "../../assets/zapzap.svg"
import GloboCortado from "../../assets/globoCortado.svg"
import Shop from "../../assets/shop.svg"
import Tablet from "../../assets/tablet.svg"
import Engrenagem from "../../assets/engrenagem.svg"
import Estrela from "../../assets/estrela.svg"
import Card1 from "../../assets/beatsGondola.png"
import Card2 from "../../assets/beatsPortao.png"
import Card3 from "../../assets/brahmaPortao.png"
import Ambev from "../../assets/logoAmbev.png"
import Arcor from "../../assets/logoArcor.png"
import Kfc from "../../assets/logoKfc.png"
import Shell from "../../assets/logoShell.png"
import Mars from "../../assets/logoMars.png"
import Bk from "../../assets/logoBK.png"
import Oxxo from "../../assets/logoOxxo.png"
import RedBull from "../../assets/logoRedBull.png"
import Pepsico from "../../assets/logoPepsico.png"
import IconeTrofeu from "../../assets/iconeTrofeu.svg"
import IconeCaminhao from "../../assets/iconeCaminhao.svg"
import IconeCamera from "../../assets/iconeCamera.svg"
import IconeTv from "../../assets/iconeTv.svg"
import TapeteGuarana from "../../assets/tapeteGuarana.png"
import TapetePepsi from "../../assets/tapetePepsi.png"
import CaminhaoDeLadinho from "../../assets/caminhaoDeLadinho.png"
import CaminhaoDeFrente from "../../assets/caminhaoDeFrente.png"
import LogoTransparente from "../../assets/logoTransparente.png"
import PepsiGrande from "../../assets/pepsiGrande.png"
import BannersShell from "../../assets/bannersShell.png"
import ParedeShell from "../../assets/paredeShell.png"
import LogoFooter from "../../assets/logoHeader.svg"
import SetaDireita from "../../assets/setaDireita.svg"
import SetaDireitaVerde from "../../assets/setaDireitaVerde.svg"
import LogoVerde from "../../assets/logoFooterEco.png"
import IconeZapZap from "../../assets/icone-zapzap.svg"
import IconeZapZapClicado from "../../assets/icone-zapzap-clicado.svg"
import Email from "../../assets/email.svg"
import EmailClicado from "../../assets/email-clicado.svg"
import VideoFooter from "../../assets/video.mp4"
import { useRef, useState } from "react"
 
export const EcoTradePagina = () => {
        const faixaVerdeRef = useRef(null);
        const nossosClientesRef = useRef(null)
        const casesRef = useRef(null)
        const contatoReft = useRef(null)
        const [srcIconeZapZap, setSrcIconeZapZap] = useState(IconeZapZap)
        const [srcIconeEmail, setSrcIconeEmail] = useState(Email)
        const [srcIconeSetaDireita, setSrcIconeSetaDireita] = useState(SetaDireita)
      
        const scrollToFaixaVerde = () => {
          faixaVerdeRef.current?.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        };

        const scrollToNossosClientes = () => {
            nossosClientesRef.current?.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
            });
          };

          const scrollToCases = () => {
            const element = casesRef.current;
            if (element) {
              const offsetTop = element.getBoundingClientRect().top + window.scrollY;
              window.scrollTo({
                top: offsetTop - 50,
                behavior: 'smooth',
              });
            }
          };

        const scrollToContato = () => {
            window.scrollTo({
                top: document.body.scrollHeight,
                behavior: 'smooth',
              });
          };
    return(
        <PaginaStyle>
            <a href="https://wa.me/5511949512218" target="_blank">
                <ReactSVG className="zapzap" src={Zapzap}/>
            </a>
            <Header 
                scrollToFaixaVerde={scrollToFaixaVerde} 
                scrollToNossosClientes={scrollToNossosClientes}
                scrollToCases={scrollToCases}
                scrollToContato={scrollToContato}
            />
            <div className="texto-bottom">
                <h2 ref={faixaVerdeRef} className="h2-header-bottom">
                    Somos uma gráfica ecológica: um parceiro estratégico para empresas que 
                    exigem <b>alta qualidade, inovação e compromisso com a sustentabilidade.</b>
                </h2>
            </div>
            <div className="faixa-verde" >
                <div className="body-desktop">
                    <h3>
                        Atendemos demandas nacionais e internacionais a nível <b>LATAM</b>, 
                        entregando soluções sob medida para <b>trade marketing e comunicação visual.</b>
                    </h3>
                    <ReactSVG className="globo-cortado" src={GloboCortado}/>
                </div>
            </div>
                <h3 className="h3-mobile">
                        Atendemos demandas nacionais e internacionais a nível <b>LATAM</b>, 
                        entregando soluções sob medida para <b>trade marketing e comunicação visual.</b>
                </h3>
                <h4 className="h4-mobile">Impressões e <b> Acabamentos</b></h4>
            <div className="div-impressoes">
                <img className="logo-transparente" src={LogoTransparente} />
                <div className="impressoras"></div>
                <div className="div-direita">
                    <div className="column">
                        <div>
                        <h4 className="h4-desktop">Impressões e <b>Acabamentos</b></h4>
                        <h5>Somos especialistas na criação e produção 
                            de <b>materiais gráficos que geram impacto e 
                            performance no ponto de venda:</b> nossas entregas 
                            comtemplam desde <b>impressões digitais e offset</b> até 
                            <b> estruturas personalizadas para varejo.</b>
                        </h5>
                        </div>
                        <div className="cards">
                            <div className="card">
                                <img src={Card1}/>
                                <span>Ponta de gôndola impressa em polionda CMYK + Verniz</span>
                            </div>
                            <div className="card">
                                <img src={Card2}/>
                                <span>Pórtico impresso em polionda CMYK + Verniz</span>
                            </div>
                            <div className="card">
                                <img src={Card3}/>
                                <span>Pórtico impresso em polionda com acabamento em verniz</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="div-produtos-servicos">
                <h3>Conheça alguns de nossos <b> produtos e serviços:</b></h3>
                <div className="cards">
                    <div className="card">
                        <ReactSVG className="icone" src={Shop}/>
                        <h5>Pórticos de entrada para <b> supermercado e eventos;</b></h5>
                    </div>
                    <div className="card">
                        <ReactSVG className="icone" src={Tablet}/>
                        <h5>Displays e materiais promocionais <b>para ponto de venda;</b></h5>
                    </div>
                    <div className="card">
                        <ReactSVG className="icone" src={Engrenagem}/>
                        <h5>Customização de equipamento <b>como adesivações;</b></h5>
                    </div>
                    <div className="card">
                        <ReactSVG className="icone" src={Estrela}/>
                        <h5>Acabamentos premium <b>a nível internacional.</b></h5>
                    </div>
                </div>
                <div className="div-h4">
                    <h4>Contamos com um <b> time de experts</b>, um <b> maquinário moderno</b> e 
                        <b> processos otimizados</b> que garantem entregas de <b> alta qualidade em larga escala.</b>
                    </h4>
                </div>
            </div>
            <div className="div-marcas" ref={nossosClientesRef}>
                <div className="body mobile">
                    <h2>Confiança das <b>maiores marcas</b> do mercado.</h2>
                    <div className="marcas">
                        <img className="ambev" src={Ambev}/>
                        <img className="mars" src={Mars}/>
                        <img className="kfc" src={Kfc}/>
                        <img className="red-bull" src={RedBull}/>
                        <div className="linha-dois">
                        <img className="shell" src={Shell}/>
                            <img className="oxxo" src={Oxxo}/>
                            <img className="pepsico" src={Pepsico}/>
                            <img className="burguer-king" src={Bk}/>
                        <img className="arcor" src={Arcor}/>
                        </div>
                    </div>
                </div>
                <div className="body desktop">
                    <h2>Confiança das <b>maiores marcas</b> do mercado.</h2>
                    <div className="marcas">
                        <img className="ambev" src={Ambev}/>
                        <img className="arcor" src={Arcor}/>
                        <img className="kfc" src={Kfc}/>
                        <img className="shell" src={Shell}/>
                        <div className="linha-dois">
                            <img className="mars" src={Mars}/>
                            <img className="burguer-king" src={Bk}/>
                            <img className="oxxo" src={Oxxo}/>
                            <img className="red-bull" src={RedBull}/>
                            <img className="pepsico" src={Pepsico}/>
                        </div>
                    </div>
                </div>
            </div>
            <div className="sustentabilidade-inovacao">
            <img className="logo-transparente" src={LogoTransparente} />
                <h2>Sustentabilidade <b>e Inovação</b></h2>
                <h5>Como é a nossa estrutura?</h5>
                <div className="div-imagem-topicos">
                    <div className="foto-sustentabilidade"></div>
                    <div className="topicos">
                        <div className="topico">
                            <div className="flex">
                                <h4 className="topico1">1.</h4>
                                <h5>
                                    <b>Fazemos o uso de energia solar </b> 
                                    para reduzir o impacto ambiental;
                                </h5>
                            </div>
                        </div>
                        <div className="topico">
                            <div className="flex">
                                <h4>2.</h4>
                                <h5><b>Promovemos a separação e reaproveitamento de água </b> para uso responsável dos recursos;</h5>
                            </div>
                        </div>
                        <div className="topico">
                            <div className="flex">
                                <h4>3.</h4>
                                <h5><b>Gerimos o descarte sustentável de resíduos</b>, seguindo os mais altos padrões ambientais;</h5>
                            </div>
                        </div>
                        <div className="topico margin0">
                            <div className="flex">
                                <h4>4.</h4>
                                <h5>Estamos em processo de certificação <b>FAMA</b>, um dos selos mais exigentes do mercado.</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="div-cases desktop" ref={casesRef}>
                <div className="titulo-case">
                    <h3>Nossos <b>cases</b></h3>
                    <div className="titulo">
                        <ReactSVG src={IconeTrofeu}/>
                        <h4>Cases Adesivações</h4>
                        <h4><b>Guaraná / Pepsi</b></h4>
                        <h5>Adesivação no chão - destaque no PDV.</h5>
                    </div>
                    <div className="cases">
                    <div className="foto-tapete"></div>
                        <div className="cases-column">
                            <figure>
                                <img src={TapeteGuarana} className="imagem2"/>
                            </figure>
                            <figure>
                                <img src={TapetePepsi} className="imagem3"/>
                            </figure>
                        </div>
                    </div>
                </div>
                <div className="titulo-case">
                    <div className="titulo">
                        <ReactSVG src={IconeCaminhao}/>
                        <h4>Case</h4>
                        <h4><b>Logística Superfrio</b></h4>
                        <h5>Envelopamento de 104 caminhões em apenas 10 semanas.</h5>
                    </div>
                    <div className="cases">
                    <div className="foto-caminhao"></div>
                        <div className="cases-column">
                            <img src={CaminhaoDeFrente} className="imagem2"/>
                            <img src={CaminhaoDeLadinho} className="imagem3"/>
                        </div>
                    </div>
                </div>
                <div className="titulo-case">
                <div className="titulo">
                        <ReactSVG src={IconeCamera}/>
                        <h4>Case Ambientação</h4>
                        <h4><b>Pepsi</b></h4>
                        <h5>Customização de ambiente e cenografia para eventos.</h5>
                    </div>
                    <div className="cases">
                    <div className="foto-futbol"></div>
                        <div className="cases-column">
                            <img src={PepsiGrande} className="imagem2 pepsi"/>
                        </div>
                    </div>
                </div>
                <div className="titulo-case">
                <div className="titulo">
                        <ReactSVG src={IconeTv}/>
                        <h4>Case</h4>
                        <h4><b>Shell Select</b></h4>
                        <h5>Ambientação de escritórios.</h5>
                    </div>
                    <div className="cases">
                    <div className="foto-parede-shell"></div>
                        <div className="cases-column">
                            <img src={BannersShell} className="imagem2"/>
                            <img src={ParedeShell} className="imagem3"/>
                        </div>
                    </div>
                </div>
            </div>
            <div className="div-cases mobile">
                <h3 className="h3-cases">Nossos <b>cases</b></h3>
                <div className="titulo-case-mobile">
                    <div className="titulo">
                        <ReactSVG src={IconeTrofeu}/>
                        <h4><b>Guaraná / Pepsi</b></h4>
                    </div>
                    <div className="cases">
                    <div className="foto-tapete"></div>
                        <div className="cases-column">
                            <figure>
                                <img src={TapeteGuarana} className="imagem2"/>
                            </figure>
                            <figure>
                                <img src={TapetePepsi} className="imagem3"/>
                            </figure>
                        </div>
                    </div>
                    <h4>Cases Adesivações</h4>
                    <h5>Adesivação no chão - destaque no PDV.</h5>
                </div>
                <div className="titulo-case-mobile">
                    <div className="titulo">
                        <ReactSVG src={IconeCaminhao}/>
                        <h4><b>Logística Superfrio</b></h4>
                    </div>
                    <div className="cases">
                    <div className="foto-caminhao"></div>
                        <div className="cases-column">
                            <img src={CaminhaoDeFrente} className="imagem2"/>
                            <img src={CaminhaoDeLadinho} className="imagem3"/>
                        </div>
                    </div>
                    <h4>Case</h4>
                    <h5>Envelopamento de 104 caminhões em apenas 10 semanas.</h5>
                </div>
                <div className="titulo-case-mobile">
                <div className="titulo">
                        <ReactSVG src={IconeCamera}/>   
                        <h4><b>Pepsi</b></h4>
                    </div>
                    <div className="cases">
                    <div className="foto-futbol"></div>
                        <div className="cases-column">
                            <img src={PepsiGrande} className="imagem2 pepsi"/>
                        </div>
                    </div>
                    <h4>Case Ambientação</h4>
                    <h5>Customização de ambiente e cenografia para eventos.</h5>
                </div>
                <div className="titulo-case-mobile">
                <div className="titulo">
                        <ReactSVG src={IconeTv}/>      
                        <h4><b>Shell Select</b></h4>
                    </div>
                    <div className="cases">
                    <div className="foto-parede-shell"></div>
                        <div className="cases-column">
                            <img src={BannersShell} className="imagem2"/>
                            <img src={ParedeShell} className="imagem3"/>
                        </div>
                    </div>
                    <h4>Case</h4>
                    <h5>Ambientação de escritórios.</h5>
                </div>
            </div>
            <footer>
                <div className="background-footer">
                <div className="background-container">
                    <video autoPlay loop muted playsInline className="background-video">
                        <source src={VideoFooter} type="video/mp4" />
                        Seu navegador não suporta vídeos em HTML5.
                    </video>

                    <div className="content">
                    <img className="logo-footer" src={LogoFooter}/>
                        <h2>Soluções completas para 
                            <b> maximizar resultados.
                        </b>
                        </h2>
                        <button 
                            onClick={() => scrollToContato()}                             
                            onMouseEnter={() => setSrcIconeSetaDireita(SetaDireitaVerde)}
                            onMouseLeave={() => setSrcIconeSetaDireita(SetaDireita)}>
                            Fale conosco 
                            <ReactSVG src={srcIconeSetaDireita} />
                        </button>
                    </div>
                </div>
                    
                </div>
                <h4 ref={contatoReft}>
                    <b>Temos o que você precisa para atender das pequenas às grandes demandas, </b>
                    garantindo prazos reduzidos e alta eficiência em todo o percurso.
                </h4>
                <div className="flex-center">
                    <img className="logo-final" src={LogoVerde}/>
                    <div className="flex-column">
                        <div className="flex icones">
                            <a href="https://wa.me/5511949512218" target="_blank">
                                {/* <img src={ZapZapVerde}/> */}
                                <ReactSVG src={srcIconeZapZap} 
                                    onMouseEnter={() => setSrcIconeZapZap(IconeZapZapClicado)}
                                    onMouseLeave={() => setSrcIconeZapZap(IconeZapZap)}
                                />
                            </a>
                            <a
                                href="https://mail.google.com/mail/?view=cm&fs=1&to=atendimento@ecotrade.net.br"
                                target="_blank"
                                rel="noopener noreferrer"
                                >
                                {/* <img src={Email} alt="Enviar e-mail via Gmail" /> */}
                                <ReactSVG src={srcIconeEmail}
                                    onMouseEnter={() => setSrcIconeEmail(EmailClicado)}
                                    onMouseLeave={() => setSrcIconeEmail(Email)}
                                />
                            </a>
                        </div>
                        <span>Rua Monastério, 51 - Vila Califórnia</span>
                        <span>CNPJ: 23.097.315/0003-66</span>
                    </div>
                </div>
                <span className="final">Ecotrade 2025 - Todos os direitos reservados</span>
            </footer>
        </PaginaStyle>
    )
}